<template>
  <van-form ref="clueForm" @submit="onSubmit" class="clueForm">
    <van-field
      size="large"
      border
      clickable
      v-model="formData.customerName"
      name="pattern"
      label="客户姓名"
      placeholder="请输入客户姓名"
      required
      :rules="rules.nameValidator"
    />
    <van-field
      size="large"
      border
      clickable
      v-model="formData.studentName"
      name="validator"
      label="学生姓名"
      placeholder="请输入学生姓名"
      required
      :rules="rules.stuNameValidator"
    />
    <van-field
      size="large"
      border
      clickable
      v-model="formData.phone"
      name="phone"
      label="手机号"
      placeholder="请输入11位手机号"
      required
      :rules="rules.phoneValidator"
    />
    <van-field name="radio" label="性别" required size="large" border clickable>
      <template #input>
        <van-skeleton
          :row="0"
          title
          title-width="80%"
          :loading="sexLoading"
          style="width: 100%; padding: 0px"
        >
          <van-radio-group v-model="formData.sex" direction="horizontal">
            <van-radio
              icon-size="18px"
              v-for="(item, index) in pickerOptions.sexInfo"
              :key="index"
              :name="item.value"
            >
              {{ item.text }}
            </van-radio>
          </van-radio-group>
        </van-skeleton>
      </template>
    </van-field>
    <van-field
      readonly
      size="large"
      border
      clickable
      name="picker"
      :value="gradeValue"
      label="年级"
      placeholder="请选择年级"
      required
      @click="showPicker('grades')"
      :rules="rules.gradeValidator"
    />
    <van-field
      readonly
      size="large"
      border
      clickable
      name="picker"
      :value="cityValue"
      label="所属城市"
      placeholder="请选择城市"
      required
      @click="showPicker('cities')"
      :rules="rules.cityValidator"
    />
    <van-field
      readonly
      size="large"
      border
      clickable
      name="picker"
      :value="productValue"
      label="产品类型"
      placeholder="请选择产品类型"
      required
      @click="showPicker('product')"
      :rules="rules.productValidator"
    />
    <van-field
      size="large"
      border
      clickable
      name="picker"
      label="意向科目"
      placeholder="请选择意向科目"
      required
      :rules="rules.subjectValidator"
    >
      <template #input>
        <van-skeleton
          :row="5"
          :loading="sexLoading"
          style="width: 100%; padding: 0px"
        >
          <van-checkbox-group v-model="subjectValue" direction="horizontal">
            <van-checkbox
              icon-size="18px"
              v-for="(item, index) in pickerOptions.subjects"
              :key="index"
              :name="item.subjectId"
            >
              {{ item.subjectName }}
            </van-checkbox>
          </van-checkbox-group>
        </van-skeleton>
      </template>
    </van-field>
    <van-field
      size="large"
      border
      clickable
      v-model="formData.adviser"
      label="推荐人姓名"
      placeholder="请输入推荐人姓名+工号"
      required
      :rules="rules.adviserValidator"
      v-if="isAdviser"
    />
    <van-field
      size="large"
      border
      clickable
      v-model="formData.source"
      label="渠道ID"
      placeholder="请输入渠道ID"
    />
    <van-field
      size="large"
      border
      clickable
      v-model="formData.comment"
      label="学员概况"
      placeholder="请输入学员概况"
    />
    <van-field
      size="large"
      border
      clickable
      v-model="formData.workCode"
      label="指定跟进顾问"
      placeholder="请输入指定跟进顾问工号"
    />
    <van-popup v-model="isShowPicker" position="bottom">
      <van-cascader
        v-if="isProductPicker"
        v-model="productValue"
        :field-names="fieldNames"
        title="请选择产品类型"
        :options="productList"
        @close="isShowPicker = false"
        @finish="onFinish"
      />
      <van-picker
        v-else
        show-toolbar
        :value-key="pickerKey === 'grades' ? 'gradeName' : 'cityName'"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="isShowPicker = false"
      />
    </van-popup>
    <div style="margin: 16px">
      <van-button
        :loading="isLoading"
        round
        block
        type="info"
        native-type="submit"
        >提交</van-button
      >
    </div>
  </van-form>
</template>

<script>
import { rules } from "./rules";
import { config } from "./config";
import { debounce } from "../../utils/utils";

export default {
  name: "clueYachForm",
  data() {
    return {
      appid: config.appId,
      sexLoading: false,
      rules,
      formData: {
        customerName: "",
        studentName: "",
        phone: "",
        sex: 0,
        grade: "",
        cityCode: "",
        product: "",
        subject: "",
        adviser: "",
        source: "",
        comment: "",
        workCode: "",
      },
      isAdviser: false,
      pickerOptions: {},
      columns: [],
      productOptions: [],
      productValue: "",
      gradeValue: "",
      cityValue: "",
      subjectValue: [],
      isShowPicker: false,
      pickerKey: "",
      productList: [],
      isProductPicker: false,
      isLoading: false,
      fieldNames: {
        text: "label",
        value: "value",
        children: "children",
      },
    };
  },
  methods: {
    onSubmit() {
      this.isLoading = true;
      this.formData.subject = this.subjectValue.join(",");
      this.formData.source = this.formData.source || config.source;
      if (this.formData.adviser) {
        let adviserInfo = this.formData.adviser.split("+");
        if (adviserInfo.length != 2) {
          this.$toast("推荐人格式不正确");
          return;
        }
      }
      if (this.formData.adviser.length <= 0) {
        this.isAdviser = true;
      }
      this.$api.clueForm.postClueSubmit(this.formData).then(
        (res) => {
          if (res.ret && res.errcode === 0) {
            this.$toast("提交成功");
            this.formData = {
              customerName: "",
              studentName: "",
              phone: "",
              sex: 0,
              grade: "",
              cityCode: "",
              product: "",
              subject: "",
              comment: "",
              workCode: "",
              source: "",
            };
            this.productValue = "";
            this.gradeValue = "";
            this.cityValue = "";
            this.subjectValue = [];
          } else {
            this.$toast("提交失败，请重试");
          }
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },
    showPicker(key) {
      if (key === "product") {
        this.isProductPicker = true;
      } else {
        this.pickerKey = key;
        this.isProductPicker = false;
        this.columns = this.pickerOptions[key];
      }
      this.isShowPicker = true;
    },
    onConfirm(val) {
      if (this.pickerKey === "grades") {
        this.formData.grade = val.gradeId;
        this.gradeValue = val.gradeName;
      }
      if (this.pickerKey === "cities") {
        this.formData.cityCode = val.cityCode;
        this.cityValue = val.cityName;
      }
      this.isShowPicker = false;
    },
    onFinish({ value, selectedOptions }) {
      this.formData.product = value;
      this.isShowPicker = false;
      this.productValue = selectedOptions
        .map((option) => option.label)
        .join("/");
    },
    getConfig() {
      this.$api.clueForm.getConfig().then((res) => {
        this.sexLoading = false;
        if (res.ret && res.errcode === 0) {
          this.pickerOptions = res.data;
          this.productList = res.data.productList;
        }
      });
    },
  },
  created() {
    let reg = /Android|webOS|iPhone|iPod|BlackBerry/i;
    if (!reg.test(window.navigator.userAgent)) {
      var html = document.getElementsByTagName("html")[0];
      html.style.fontSize = "40px";
    }
    window.onresize = debounce(function () {
      html.style.fontSize = "40px";
    }, 1000);

    this.$api.yach.getCheckLogin(this.appid).then((res) => {
      if (JSON.stringify(res) !== "{}") {
        this.formData.adviser = res.workName + "+" + res.workCode;
      } else {
        this.isAdviser = true;
      }
      this.getConfig();
    });
  },
  mounted() {},
};
</script>

<style>
.van-checkbox--horizontal {
  margin-bottom: 0.32rem;
}
.van-cell--required:before {
  padding-left: 0.3rem;
}
.van-cell--large {
  padding-left: 0.8rem;
}
</style>
